import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { guid } from '@/mixins/guid';

export default Vue.component('edit-form', {
  template: require('./template.html'),
  mixins: [guid],
  computed: {
    ...mapGetters(['currentSite', 'viewport']),
  },
  data() {
    return {
      sendEmail: false,
      sendemailaddress: '',
      clearBtn: null,
      hookLimit: 10,
      activeHook: null,
    };
  },
  name: 'edit-form',
  props: ['droplet', 'show-edit-bubble'],
  watch: {
    showEditBubble(open) {
      if (open) {
        this.setInitialValues();
      }
    },
  },
  methods: {
    setInitialValues() {
      this.sendEmail = this.droplet.sendEmail;
      this.sendemailaddress = this.droplet.sendEmailAddress || '';
    },
    updateShouldSend() {
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        key: 'sendEmail',
        val: this.sendEmail,
      });
    },
    updateSubmissionEmail() {
      this._debounce(() => {
        this.$validator.validate('sendemailaddress', this.sendemailaddress).then(async (result) => {
          if (result) {
            const val = this.sendemailaddress !== '' ? this.sendemailaddress : null;
            this.$store.dispatch('setDropletVal', {
              drp: this.droplet,
              key: 'sendEmailAddress',
              val,
            });
          }
        });
      }, 250);
    },
    setSuccessMessage(e) {
      const val = e.currentTarget.value;
      const payload = {};
      payload.drp = this.droplet;
      payload.key = 'successMessage';
      payload.val = val.trim() === '' ? false : val;
      this.$store.dispatch('setDropletVal', payload);
    },
    setBtnTxt(e, type) {
      const val = e.currentTarget.value;
      const payload = {};
      payload.drp = this.droplet;
      payload.type = type;
      payload.text = val.trim() === '' ? false : val;
      this.$store.dispatch('setFormBtnTxt', payload);
    },
    setBubbleSize(size) {
      this.$emit('set-bubble-size', size);
    },
    setFormValues(_id) {
      this.setActiveFieldId(_id).then(() => {
        const activeField = _.find(this.droplet.fields, { _id });
        // set active field to the clicked or dropped one
        const payload = {
          drp: this.droplet,
          activeField,
        };
        this.$store.dispatch('setFormFieldActive', payload);
      });
    },
    resetFormValues() {
      this.setActiveFieldId(null).then(() => {
        const payload = {
          drp: this.droplet,
        };
        this.$store.dispatch('resetFormEditing', payload);
      });
    },
    dropFormField(p) {
      this.bounceTooltip();
      this.bounceValidation();
      this.setFormValues(this.droplet.fields[p.newIndex]._id);
    },
    setNewFieldTabActive() {
      const payload = {
        drp: this.droplet,
        editingField: false,
        addingNewField: true,
      };
      this.$store.dispatch('setFormsEditTabs', payload);
    },
    setEditFieldTabActive() {
      const payload = {
        drp: this.droplet,
        editingField: true,
        addingNewField: false,
      };
      this.$store.dispatch('setFormsEditTabs', payload);
    },
    updateLabel(e) {
      const val = e.currentTarget.value;
      const payload = {};
      payload.drp = this.droplet;
      payload.label = val.trim() === '' ? false : val;
      payload.activeId = this.droplet.activeFieldId;
      this.$store.dispatch('setFormFieldLabel', payload);
    },
    setNoLabel(e) {
      const checked = e.currentTarget.checked;
      const payload = {};
      payload.drp = this.droplet;
      payload.noLabel = checked;
      payload.activeId = this.droplet.activeFieldId;
      this.$store.dispatch('setFormFieldNoLabel', payload);
    },
    async setRequired(e) {
      const checked = e.currentTarget.checked;
      const payload = {};
      payload.drp = this.droplet;
      payload.required = checked;
      payload.activeId = this.droplet.activeFieldId;
      await this.$store.dispatch('setFormFieldRequired', payload);
      this.bounceValidation();
    },
    setTooltip(e) {
      const val = e.currentTarget.value;
      const payload = {};
      payload.drp = this.droplet;
      payload.toolTip = val.trim() === '' ? false : val;
      payload.activeId = this.droplet.activeFieldId;
      this.promise(this.$store.dispatch('setFormFieldTooltip', payload), 'setting tooltip').then(
        () => {
          this.bounceTooltip();
        },
      );
    },
    setPlaceholder(e) {
      const val = e.currentTarget.value;
      const payload = {};
      payload.drp = this.droplet;
      payload.placeholder = val.trim() === '' ? false : val;
      payload.activeId = this.droplet.activeFieldId;
      this.$store.dispatch('setFormFieldPlaceholder', payload);
    },
    setOther(e) {
      const checked = e.currentTarget.checked;
      const payload = {};
      payload.drp = this.droplet;
      payload.other = checked;
      payload.activeId = this.droplet.activeFieldId;
      this.$store.dispatch('setFormFieldOther', payload);
    },
    updateOption(e, i) {
      const val = e.currentTarget.value;
      const payload = {};
      payload.drp = this.droplet;
      payload.value = val.trim() === '' ? false : val;
      payload.index = i;
      payload.activeId = this.droplet.activeFieldId;
      this.$store.dispatch('setFormFieldOption', payload);
    },
    async removeOption(i) {
      const payload = {};
      payload.drp = this.droplet;
      payload.index = i;
      payload.activeId = this.droplet.activeFieldId;
      await this.$store.dispatch('removeFormFieldOption', payload);
      this.bounceValidation();
    },
    async addOption() {
      const payload = {};
      payload.drp = this.droplet;
      payload.option = { value: 'New Option' };
      payload.activeId = this.droplet.activeFieldId;
      await this.$store.dispatch('addFormFieldOption', payload);
      this.bounceValidation();
    },
    addHook() {
      if (!this.droplet.webhooks) {
        this.$store.dispatch('setDropletVal', {
          drp: this.droplet,
          key: 'webhooks',
          val: [],
        });
      }
      if (this.droplet.webhooks.length >= this.hookLimit) {
        return;
      }
      this.$store.dispatch('pushDropletVal', {
        array: this.droplet.webhooks,
        val: {
          _id: this.guid(),
          url: false,
          payload: [],
        },
      });
    },
    updateHook(e, hook) {
      this.$store.dispatch('setDropletVal', {
        drp: hook,
        key: 'url',
        val: this._getInputVal(e.target.value),
      });
    },
    updateKv(params) {
      this.$store.dispatch('setDropletVal', {
        drp: params.item,
        key: params.key,
        val: this._getInputVal(params.$event.target.value),
      });
    },
    addKeyValue() {
      if (!this.activeHook.payload) {
        this.$store.dispatch('setDropletVal', {
          drp: this.activeHook,
          key: 'payload',
          val: [],
        });
      }
      this.$store.dispatch('pushDropletVal', {
        array: this.activeHook.payload,
        val: {
          key: false,
          value: false,
        },
      });
    },
    removeField(i, _id) {
      const payload = {};
      payload.drp = this.droplet;
      payload.index = i;
      this.promise(this.$store.dispatch('removeFormField', payload), 'removing form field').then(
        () => {
          this.bounceTooltip();
          this.bounceValidation();
        },
      );
      if (_id === this.droplet.activeFieldId) {
        this.resetFormValues();
      }
    },
    setActiveFieldIndex(v) {
      const payload = {};
      payload.drp = this.droplet;
      payload.activeFieldIndex = v;
      return new Promise((resolve) => {
        if (this.$store.dispatch('setFormFieldActiveIndex', payload)) {
          resolve();
        }
      });
    },
    setActiveFieldId(v) {
      const payload = {};
      payload.drp = this.droplet;
      payload.activeFieldId = v;
      return new Promise((resolve) => {
        if (this.$store.dispatch('setFormFieldActiveId', payload)) {
          resolve();
        }
      });
    },
    setLocals(v) {
      this.$emit('set-display', v);
    },
    // our global _DropletOptions calls this on cancel if
    // we want any data options in this component reverted
    drzRevertData() {
      this.$emit('css-generator');
      const activeId = this.droplet.activeFieldId;
      if (_.isNull(activeId)) {
        this.resetFormValues();
      } else {
        this.setFormValues(activeId);
      }
      this.bounceTooltip();
      this.bounceValidation();
    },
    bounceTooltip() {
      this.$vnode.context.unBindToolTip();
      this.$vnode.context.bindToolTip();
    },
    bounceValidation() {
      this.$vnode.context.unBindValidation();
      this.$vnode.context.bindValidation();
    },
    promise(action, error) {
      return new Promise((resolve, reject) => {
        if (action) {
          resolve();
        } else {
          reject(Error(error));
        }
      });
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/form/components/_edit-options/index.js